import { createSlice } from "@reduxjs/toolkit";

type isLoadingType = {
    isLoading: boolean
}
const initialState: isLoadingType = {
    isLoading: false
}

const IsLoadingSlice = createSlice({
    name: "loading",
    initialState,
    reducers: {
        setLoading: (state) => {
            state.isLoading = true
        },
        unsetLoading: (state) => {
            state.isLoading = false
        }
    }
})

export const { setLoading ,unsetLoading } = IsLoadingSlice.actions
export default IsLoadingSlice.reducer